import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { helpButtonStyles } from './styles';

const HELP_TEXT =
  "This monitor displays only incidents configured with '[MaxCellT_Rack_Incident]' in the alert name. Configure alerts in the Alerts Config section to have them appear here.";

const HelpButton: React.FC = () => (
  <Tooltip title={HELP_TEXT} placement='left' arrow>
    <IconButton
      size='small'
      sx={helpButtonStyles}
      aria-label='Help information about incident monitoring'
    >
      <HelpOutlineIcon fontSize='small' />
    </IconButton>
  </Tooltip>
);

HelpButton.displayName = 'HelpButton';

export default HelpButton;
